/* eslint-disable import/prefer-default-export */
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#114559',
    },
    text: {
      white: '#ffffff',
    },
  },
});
